export const messageDurationTime = 3500;
export const messageAnimationEndTime = messageDurationTime - 1000;
